import React from 'react';
import { UilFacebookF, UilInstagram, UilPhone, UilEnvelope, UilMapMarker, UilLinkedin } from '@iconscout/react-unicons';
import YelpIcon from '../assets/Icons/yelp-icon.jpg';
import Logo from '../assets/Images/logo2.png';
import { Link } from 'react-router-dom';

export default function FooterPage() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home',             path: '/' },
    { name: 'Services',         path: '/services' },
    { name: 'About Us',         path: '/about' },
    { name: 'Gallery',          path: '/gallery' },
    { name: 'Contact',          path: '/contact' },
    { name: 'Request Estimate', path: '/request' },
  ];

  const legalLinks = [
    { name: 'Terms & Conditions', path: '/terms-and-conditions' },
    { name: 'Privacy Policy',     path: '/privacy' },
  ];

  const serviceAreas = ['Bellevue', 'Redmond', 'Seattle', 'Kirkland', 'Sammamish', 'Woodinville', 'Issaquah', 'Bothell'];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="h-1 bg-gradient-to-r from-gold-500 via-gold-400 to-gold-600" />

      <div className="max-w-7xl mx-auto px-6 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <img src={Logo} alt="Fabiana Fabulous Cleaning Services" className="h-12 w-auto" />
              <div>
                <p className="text-sm font-bold text-white leading-tight">Fabiana Fabulous</p>
                <p className="text-xs text-brand-400 font-medium">Cleaning Services</p>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Premium cleaning services for homes & businesses across Seattle & Eastside since 1998.
              Licensed, bonded & insured.
            </p>
            <div className="flex gap-2">
              <a href="https://www.facebook.com/Fabulouscleaner/" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-slate-800 hover:bg-brand-600 rounded-lg flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200">
                <UilFacebookF size={16} />
              </a>
              <a href="https://www.yelp.com/biz/fabiana-fabulous-cleaning-services-redmond-4" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-slate-800 hover:bg-brand-600 rounded-lg flex items-center justify-center overflow-hidden transition-all duration-200">
                <img src={YelpIcon} alt="Yelp" className="w-4 h-4 opacity-60 hover:opacity-100 transition-opacity" />
              </a>
              <a href="https://www.instagram.com/fabianallc/" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-slate-800 hover:bg-brand-600 rounded-lg flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200">
                <UilInstagram size={16} />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold text-brand-400 uppercase tracking-wider mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-slate-800 rounded-lg flex items-center justify-center shrink-0 mt-0.5">
                  <UilMapMarker size={14} className="text-brand-400" />
                </div>
                <p className="text-sm text-slate-400">Lake Stevens, WA 98258</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-slate-800 rounded-lg flex items-center justify-center shrink-0 mt-0.5">
                  <UilPhone size={14} className="text-brand-400" />
                </div>
                <div className="space-y-1">
                  <a href="tel:4258296092" className="block text-sm text-slate-400 hover:text-brand-400 transition-colors">(425) 829-6092</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-slate-800 rounded-lg flex items-center justify-center shrink-0 mt-0.5">
                  <UilEnvelope size={14} className="text-brand-400" />
                </div>
                <a href="mailto:fabulous@fabycleaners.com" className="text-sm text-slate-400 hover:text-brand-400 transition-colors break-all">
                  fabulous@fabycleaners.com
                </a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-bold text-brand-400 uppercase tracking-wider mb-6">Navigation</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-xs font-bold text-brand-400 uppercase tracking-wider mb-6">Service Areas</h4>
            <div className="flex flex-wrap gap-2">
              {serviceAreas.map((area) => (
                <span key={area} className="bg-slate-800 text-slate-400 text-xs font-medium px-2.5 py-1 rounded-lg">
                  {area}
                </span>
              ))}
            </div>
            <p className="text-xs text-slate-500 mt-4 leading-relaxed">And many more areas across the greater Seattle region.</p>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {currentYear} Fabiana Fabulous Cleaning Services LLC</p>
          <div className="flex gap-5">
            {legalLinks.map((link) => (
              <Link key={link.path} to={link.path} className="text-xs text-slate-500 hover:text-brand-400 transition-colors">
                {link.name}
              </Link>
            ))}
          </div>
          <a href="https://www.linkedin.com/in/victor-villagrana/" target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-brand-400 transition-colors">
            <span>Designed by Victor</span>
            <UilLinkedin size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
}
